import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from "vue-property-decorator";
let DashboardUserWidget = class DashboardUserWidget extends Vue {
    get iconSrc() {
        return require(`@/assets/${this.icon}`);
    }
};
__decorate([
    Prop({ type: Number, required: true })
], DashboardUserWidget.prototype, "value", void 0);
__decorate([
    Prop({ type: String, required: true })
], DashboardUserWidget.prototype, "label", void 0);
__decorate([
    Prop({ type: String, required: true })
], DashboardUserWidget.prototype, "icon", void 0);
DashboardUserWidget = __decorate([
    Component({})
], DashboardUserWidget);
export default DashboardUserWidget;
